import createNamedContext from 'utils/createNamedContext';
import * as React from 'react';
import { useRequest } from 'ahooks';
import { Spin, message } from 'antd';
import { getUnConfigBootStrapStoreInfo } from '../service';
import type { BootProcessingConfigType, GetUnConfigBootStrapStoreInfoReturn } from '../types/api';
import { useTranslate } from '@tolgee/react';
import { useGetCCV, useSubmitCCV } from '../hooks/useConfiguration';

/**
 * 基础和进阶配置阶段未完成配置的store信息
 */
const UnConfigBootStoreContext = createNamedContext<GetUnConfigBootStrapStoreInfoReturn>(
  'UnConfigBootStoreContext',
  null!,
);

export const useUnConfigBootStoreContext = () => {
  const context = React.useContext(UnConfigBootStoreContext);
  if (!context) {
    throw new Error('useUnConfigBootStoreContext must be used within a UnConfigBootStoreContext');
  }
  return context;
};

export const UnConfigBootStoreProvider = (props: {
  configType: BootProcessingConfigType;
  children: React.ReactNode;
}) => {
  const { configType, children } = props;
  const { t } = useTranslate();
  const unConfigBootStore = useGetCCV('unConfigBootStore');
  const submitCCV = useSubmitCCV();
  const { data, loading } = useRequest(
    () =>
      getUnConfigBootStrapStoreInfo({
        type: (
          {
            BASIC: 1,
            ADVANCED: 2,
            AI_MODEL: 3,
            MARKETING: 4,
            AI_SALE_BOT: 5,
            AI_ASSISTANT_BOT: 6,
            AI_SALE_BOT_ADVANCED: 7,
          } as const
        )[configType],
      }),
    {
      ready: !unConfigBootStore || unConfigBootStore?.length === 0,
      onSuccess: (data) => {
        submitCCV('unConfigBootStore', data);
      },
      onError: () => {
        message.error(t('phrase.获取数据失败，请稍后再试'));
      },
    },
  );

  if (loading) {
    return (
      <div className="flex h-full items-center justify-center">
        <Spin />
      </div>
    );
  }
  const value = data || unConfigBootStore;

  if (!value) return null;
  return (
    <UnConfigBootStoreContext.Provider value={value}>{children}</UnConfigBootStoreContext.Provider>
  );
};
